export default state => {
	return Object.keys(state.auth.claims).includes('rga');
};
